import * as React from "react";
import { Row, Col } from "reactstrap";
import { IMatchResponse } from "src/share/types/match";
import BiometricaMatches from "./BiometricaMatches";
import AdhocMatches from "./AdhocMatches";
import GMCNgineMatches from "./GMCNgineMatches";

export interface IInformationPersonCardProps {
  loading?: boolean;
  type?: string;
  deleteMatch?: (matchId) => () => void;
  deleting: boolean;
}

export enum MatchesType {
  Biometrica = "biometrica",
  Adhoc = "adhoc",
  GMCNgine = "gmcngine"
}

const MatchesCard = (props: IMatchResponse & IInformationPersonCardProps) => {
  const { matchInfo, matches, deleteMatch, deleting, caseInfo, childInfo, type, loading } = props;
  const hasMatches = matches.length > 0;
  const isAdhoc = type === "adhoc" && hasMatches;
  const renderMatches = () => {
    const matchesTypes = {
      [MatchesType.Biometrica]: <BiometricaMatches matchInfo={matchInfo} />,
      [MatchesType.Adhoc]: <AdhocMatches matches={matches} deleteMatch={deleteMatch} deleting={deleting} />,
      [MatchesType.GMCNgine]: (
        <GMCNgineMatches matches={matches} caseInfo={caseInfo} childInfo={childInfo} deleteMatch={deleteMatch} deleting={deleting} />
      )
    };
    return (type && matchesTypes[type]) || null;
  };
  return (
    <Row>
      {!loading ? (
        <>
          {isAdhoc && hasMatches && (
            <Col md={12}>
              <p className="requester">This match was requested by: {(matches[0] as any).requester || "Unknown"}</p>
            </Col>
          )}
          {renderMatches()}
        </>
      ) : null}
    </Row>
  );
};

export default React.memo(MatchesCard);



// WEBPACK FOOTER //
// ./src/modules/Recognition/Match/components/MatchesCard.tsx